import CustomerSuccessTeam from './CustomerSuccessTeam';
import OnboardingTeam from './OnboardingTeam';
import RestaurantDirectory from './RestaurantDirectory';
import ServiceProviderDashboard from './ServiceProviderDashboard';

export default {
  CustomerSuccessTeam,
  OnboardingTeam,
  RestaurantDirectory,
  ServiceProviderDashboard,
};
